export const GET_STORIES = 'GET_STORIES';
export const GET_STORY = 'GET_STORY';
export const GET_CRITS = 'GET_STORY_CRITS';
export const ADD_STORY = 'ADD_STORY';
export const ADD_STORY_CRIT = 'ADD_STORY_CRIT';
export const POST_ERROR = 'POST_ERROR';